export default "__VITE_ASSET__BrESnnD3__ 100w";